// Reuses backend /dues for accounts; mirrors MRDues but with broader source.
import React, { useEffect, useState } from "react";
import api, { formatINR } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Printer } from "lucide-react";

const TYPES = ["", "doctor", "distributor", "retailer", "patient", "other"];

export default function AccountsDues() {
    const [type, setType] = useState("");
    const [from, setFrom] = useState(""); const [to, setTo] = useState("");
    const [data, setData] = useState({ rows: [], total_billed: 0, total_paid: 0, total_outstanding: 0 });

    const load = async () => {
        const params = {};
        if (type) params.customer_type = type;
        if (from) params.from_date = from;
        if (to) params.to_date = to;
        const { data } = await api.get("/dues", { params });
        setData(data);
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    return (
        <div data-testid="accounts-dues" className="space-y-4">
            <div className="flex items-center justify-between">
                <div><div className="label-eyebrow text-sky-700">Receivables</div><h1 className="font-serif text-4xl text-stone-900">Dues report</h1></div>
                <Button onClick={() => window.print()} variant="outline" className="rounded-none border-stone-400"><Printer className="w-4 h-4 mr-2" />Print</Button>
            </div>

            <div className="bg-white border border-stone-200 p-4 grid sm:grid-cols-4 gap-3 print:hidden">
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">Type</Label>
                    <Select value={type || "all"} onValueChange={(v) => setType(v === "all" ? "" : v)}>
                        <SelectTrigger className="rounded-none border-stone-300 mt-1"><SelectValue placeholder="All" /></SelectTrigger>
                        <SelectContent><SelectItem value="all">All types</SelectItem>{TYPES.filter(Boolean).map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
                    </Select>
                </div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">From</Label><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-none border-stone-300 mt-1" /></div>
                <div><Label className="text-xs uppercase tracking-widest text-stone-500">To</Label><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-none border-stone-300 mt-1" /></div>
                <div className="flex items-end"><Button onClick={load} className="rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50">Apply</Button></div>
            </div>

            <div className="grid sm:grid-cols-3 gap-3">
                <KPI label="Billed" value={formatINR(data.total_billed)} />
                <KPI label="Paid" value={formatINR(data.total_paid)} />
                <KPI label="Outstanding" value={formatINR(data.total_outstanding)} highlight />
            </div>

            <div className="bg-white border border-stone-200 overflow-x-auto">
                <table className="w-full text-sm">
                    <thead><tr className="bg-stone-50 border-b border-stone-200">
                        <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">Customer</th>
                        <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">Type</th>
                        <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">Phone</th>
                        <th className="text-left p-3 text-xs uppercase tracking-widest text-stone-500">City</th>
                        <th className="text-right p-3 text-xs uppercase tracking-widest text-stone-500">Billed</th>
                        <th className="text-right p-3 text-xs uppercase tracking-widest text-stone-500">Paid</th>
                        <th className="text-right p-3 text-xs uppercase tracking-widest text-stone-500">Outstanding</th>
                    </tr></thead>
                    <tbody>
                        {data.rows.length === 0 ? <tr><td colSpan={7} className="p-8 text-center text-stone-500">Nothing here.</td></tr> :
                            data.rows.map((r, i) => (
                                <tr key={i} className="border-b border-stone-100">
                                    <td className="p-3 font-medium">{r.name}</td>
                                    <td className="p-3 text-xs uppercase tracking-widest text-stone-500">{r.customer_type}</td>
                                    <td className="p-3 text-stone-500">{r.phone}</td>
                                    <td className="p-3 text-stone-500">{r.city}</td>
                                    <td className="p-3 text-right">{formatINR(r.billed)}</td>
                                    <td className="p-3 text-right">{formatINR(r.paid)}</td>
                                    <td className="p-3 text-right font-medium text-amber-700">{formatINR(r.outstanding)}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const KPI = ({ label, value, highlight }) => (
    <div className={`bg-white border ${highlight ? "border-amber-500" : "border-stone-200"} p-4`}>
        <div className="label-eyebrow text-stone-500">{label}</div>
        <div className={`font-serif text-2xl mt-1 ${highlight ? "text-amber-700" : "text-stone-900"}`}>{value}</div>
    </div>
);
